import React, { Component } from 'react'
import Activity from "framework/containers/Activity"

//redux
import { connect } from 'react-redux'
import { mapStateToProps, mapDispatchToProps } from 'framework/utils/Redux'

class FreightCurrencyActivity extends Component {

	constructor(props){
		super(props)
		this.RenderedComponent = import("app/components/Freight/Currency/CurrencyBrowser")
	}

	render() {
		return (
			<Activity 
				name="FreightCurrency"
				RenderedComponent={this.RenderedComponent}
				context="FreightCurrency"
			/>
		)
	}
}

export default connect(mapStateToProps,mapDispatchToProps)(FreightCurrencyActivity)
